export default __webpack_public_path__ + "static/media/smkn1.a32fdd17.png";